import React, { useEffect, useState } from "react";

import { useHistory } from "react-router-dom";

import { useOrganizationBranchDetails } from "shared/hooks/useOrganizationBranchDetails";
import { tariffStatusOf, timeLeftLabel } from "shared/lib/tariffStatus";
import { ConfirmDialog } from "shared/ui";

// Один показ за сессию: это состояние интерфейса, а не сервера, и переменная модуля живёт
// ровно столько же, сколько вкладка.
let shownInThisSession = false;

export const TariffExpiredDialog = () => {
    const history = useHistory();
    const { branch } = useOrganizationBranchDetails();

    const [open, setOpen] = useState<boolean>(false);

    const tariff = branch?.tariff ?? null;
    const status = tariff ? tariffStatusOf(tariff, Date.now()) : null;

    useEffect(() => {
        if (shownInThisSession || status === null || status === "active") return;

        shownInThisSession = true;
        setOpen(true);
    }, [status]);

    if (!tariff || status === null || status === "active") return null;

    const menusLeft = timeLeftLabel(tariff.menusActiveTillDate, Date.now());

    return (
        <ConfirmDialog
            open={open}
            title={status === "overdue" ? "Тариф просрочен" : "Тариф истёк"}
            description={
                status === "overdue"
                    ? `Меню станут неактивны через ${menusLeft}.`
                    : "Чтобы включить меню, подключите один из тарифов."
            }
            confirmLabel="К тарифам"
            tone="primary"
            onConfirm={() => {
                setOpen(false);
                history.push("/settings/tariff");
            }}
            onClose={() => setOpen(false)}
        />
    );
};
